import './whatYouGetSection.css'
import { Col, Row } from "react-bootstrap"
import whatYouGetImg from "../../Assets/images/wul.png"
import correct from "../../Assets/images/Frame 34.png"
import { useTranslation } from 'react-i18next'
const WhatYouGetSection = ({data=[],img=whatYouGetImg}) => {

    const {t } = useTranslation()
    return (
        <section className="what-you-get-section ">
            <Row>
                <Col lg={6}>
                    <img src={img} alt="whatYouGetImg" className="w-100 mt-5" />
                </Col>
                <Col lg={6} className="d-flex flex-column justify-content-center ">
                    <h2 className="mb-4">{t("what_you_get")}</h2>
                    <div>
                        {data.map((item, index) => (
                            <div key={index} className="mb-3 d-flex align-items-start">
                                <img src={correct} alt="checkIcon" className="me-3 mt-1 checkIcon" />
                                 <p
                                    dangerouslySetInnerHTML={{ __html: item?.description }}
                                />
                            </div>
                        ))}
                    </div>
                </Col>
            </Row>
        </section>
    )
}

export default WhatYouGetSection
